<template>
    <div v-if="active" class="card">
        <div class="card-body">
            <PageHeader v-if="noBSL" :title="title" variant="small" class="mb-4" />
            <PageHeader v-else :title="title2" variant="small" class="mb-4" />
            <p v-if="noBSL">{{screenData.text.unableToAdd}}</p>
            <p v-else>{{screenData.text.unableToSendCode}}</p>
            <p v-html="screenData.text.clickToLogin"></p>
            <ActionList :actions="screenData.actions" @skip-mfa-login="continueLogin"></ActionList>
        </div>
    </div>
</template>

<script>
    import ActionList from '../entities/ActionList.vue';
    import PageHeader from '../entities/PageHeader.vue';
    import {PostAuthHandler} from '../mixins/PostAuthHandler.js';

    export default {
        name: "SkipMFA",

        components: {
            ActionList,
            PageHeader
        },

        mixins: [
            PostAuthHandler
        ],
        
        props: {
            screenData: Object,
        },

        data: function() {
            return {
                active: false,
                links: null,
                flow: "",
                noBSL: false
            }
        },

        methods: {
            show: function(data) {
                this.links = data.links;
                this.flow = data.flow;
                this.noBSL = data.noBSL;
                this.active = true;
            },

            hide: function() {
                this.active = false;
            },

            continueLogin: function() {
                this.$emitter.emit('start-loading','skip-mfa-login');
                this.start(this.links);
            }
        },
        computed: {
            title: function() {
                return this.flow + ": " + this.screenData.text.cardTitleNoAdd;
            },
            title2: function(){
                return this.flow + ": " + this.screenData.text.cardTitleNoCodeDelivery;
            }
        }
    }
</script>
